import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ChangeDetectorRef,
} from "@angular/core";

@Component({
  selector: "evrideo-time-slice",
  templateUrl: "./time-slice.component.html",
  styleUrls: ["./time-slice.component.scss"],
})
export class TimeSliceComponent implements OnInit {
  @Input() timePeriod: string;
  @Input() timeSlice: number;
  @Input() isHour: boolean = false;
  @Output() valueChanged = new EventEmitter<string | number>();
  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {}

  changeValue(direction: string) {
    if (this.timePeriod) {
      this.togglePeriod();
    } else {
      if (direction === "up") {
        if (
          (this.isHour && this.timeSlice < 23) ||
          (!this.isHour && this.timeSlice < 59)
        ) {
          this.timeSlice++;
          this.valueChanged.emit(this.timeSlice);
        }
      } else {
        if (this.timeSlice > 0) {
          this.timeSlice--;
          this.valueChanged.emit(this.timeSlice);
        }
      }
    }
  }
  togglePeriod() {
    this.timePeriod = this.timePeriod === "AM" ? "PM" : "AM";
    this.valueChanged.emit(this.timePeriod);
  }

  onChange(event) {
    try {
      let number = Number(event);
      let upperLimit = 59;
      if (this.isHour) {
        upperLimit = 23;
      }
      if (number < 0 || number > upperLimit) {
        number = this.timeSlice;
      }
      if (number !== this.timeSlice) {
        this.timeSlice = number;
        this.valueChanged.emit(this.timeSlice);
      }
    } catch {}
  }
}
